(function() { window.GUID_7d5626ea_2890_46f5_b1a6_ffc67714d10c = { getGuid: function() { return "7d5626ea-2890-46f5-b1a6-ffc67714d10c"; } }; })();
var CS;
(function (CS) {
    var CamLight;
    (function (CamLight) {
        var Models;
        (function (Models) {
            var Enums;
            (function (Enums) {
                let PocketEmplacement;
                (function (PocketEmplacement) {
                    PocketEmplacement[PocketEmplacement["TopLeft"] = 0] = "TopLeft";
                    PocketEmplacement[PocketEmplacement["TopRight"] = 1] = "TopRight";
                    PocketEmplacement[PocketEmplacement["SideLeft"] = 2] = "SideLeft";
                    PocketEmplacement[PocketEmplacement["SideRight"] = 3] = "SideRight";
                    PocketEmplacement[PocketEmplacement["BottomLeft"] = 4] = "BottomLeft";
                    PocketEmplacement[PocketEmplacement["BottomRight"] = 5] = "BottomRight";
                    PocketEmplacement[PocketEmplacement["OutsideTheTable"] = 6] = "OutsideTheTable";
                    PocketEmplacement[PocketEmplacement["Unknown"] = 7] = "Unknown";
                    PocketEmplacement[PocketEmplacement["NoPocket"] = -1] = "NoPocket";
                })(PocketEmplacement = Enums.PocketEmplacement || (Enums.PocketEmplacement = {}));
            })(Enums = Models.Enums || (Models.Enums = {}));
        })(Models = CamLight.Models || (CamLight.Models = {}));
    })(CamLight = CS.CamLight || (CS.CamLight = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PocketEmplacement.pre.js.map
